import SmartphoneIcon from "@mui/icons-material/Smartphone";

interface IIcon {
  color: string;
}

const SmartphoneConnected: React.FC<IIcon> = ({ color }) => {
  return <SmartphoneIcon sx={{ color }} />;
};

export default SmartphoneConnected;
